export default "__VITE_ASSET__OCpcrucn__"